import React, { FC } from 'react';
import classNames from 'classnames';
import classes from './styles/validationMessage.module.scss';
import { PaddingBox } from '../../PaddingBox';
import { ControlGroupProps } from '../types';

export const MessageValidationSection: FC<React.PropsWithChildren<ControlGroupProps>> = (props) => {
	const { valid, validationMessage, className } = props;

	if (valid) {
		return null;
	}

	const componentClasses = classNames(classes.validationMessage, className);

	return (
		<PaddingBox
			className={componentClasses}
			dataTestId='messageValidationSection'
			topTiny
		>
			{validationMessage}
		</PaddingBox>
	);
};
